import { render, staticRenderFns } from "./crossTabulation.vue?vue&type=template&id=411a38fc&scoped=true"
import script from "./crossTabulation.vue?vue&type=script&lang=js"
export * from "./crossTabulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411a38fc",
  null
  
)

export default component.exports